import { useQuery } from '@tanstack/react-query';
import { configuratorService } from '@ui/services';

const getConfigurationQuery = (siteCode: string, id: string) => {
  return {
    queryKey: ['configuration', id],
    queryFn: () => configuratorService.getConfiguration(siteCode, id),
  };
};

export function useGetConfiguration(siteCode: string, id?: string) {
  return useQuery({
    // undefined id is handled by the enabled property
    ...getConfigurationQuery(siteCode, id as string),
    enabled: !!id,
  });
}
